import { initializeApp } from 'firebase/app';
import { collection, getDocs, getFirestore, query } from 'firebase/firestore/lite';
import { getStorage } from 'firebase/storage';
import Header from '../Types/header';
import samplebook from '../Types/samplebook';

const FAIL = 'fail';
const SUCCESS = 'success';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage();

const SampleBookService = {
  getMainHeader: async () => {
    const data: Header[] = [];
    try {
      const q = query(collection(db, 'MainHeader'));

      const res = await getDocs(q);

      res.forEach((doc) => {
        const d = doc.data();
        data.push({ id: doc.id, name: d.name, value: d.value, index: d.index });
      });
      return {
        status: SUCCESS,
        data: data,
      };
    } catch (error) {
      console.log(error);
      return {
        status: FAIL,
        data: data,
      };
    }
  },
  getSampleBookList: async () => {
    const data: samplebook[] = [];
    try {
      const q = query(collection(db, 'AllSampleData'));

      const res = await getDocs(q);

      res.forEach((doc) => {
        const d = doc.data();
        let param: samplebook = {
          id: doc.id,
          design: d.design,
          main: d.main,
          sub: d.sub,
          url: d.url,
        };
        if (!!d.position && d.position !== '') {
          param.position = d.position;
        }
        data.push(param);
      });
      return {
        status: SUCCESS,
        data: data,
      };
    } catch (error) {
      console.log(error);
      return {
        status: FAIL,
        data: data,
      };
    }
  },
  getColorNameList: async () => {
    const data: { color: string; value: string[] }[] = [];
    try {
      const q = query(collection(db, 'ColorList'));

      const res = await getDocs(q);

      res.forEach((doc) => {
        const d = doc.data();
        let param: { color: string; value: string[] } = {
          color: d.color,
          value: d.value,
        };

        data.push(param);
      });
      return {
        status: SUCCESS,
        data: data,
      };
    } catch (error) {
      console.log(error);
      return {
        status: FAIL,
        data: data,
      };
    }
  },
  getPDF: async () => {
    const data: { design: string; pdf: string }[] = [];
    try {
      const q = query(collection(db, 'SampleBookPDF'));

      const res = await getDocs(q);

      res.forEach((doc) => {
        const d = doc.data();
        let param: { design: string; pdf: string } = {
          design: d.design,

          pdf: d.pdf,
        };
        data.push(param);
      });
      return {
        status: SUCCESS,
        data: data,
      };
    } catch (error) {
      console.log(error);
      return {
        status: FAIL,
        data: data,
      };
    }
  },
};

export default SampleBookService;
